export default __webpack_public_path__ + "static/media/sat.70a8c9d0.png";